import { Store, Module, ActionContext } from "vuex";
import ListModule from "./list-module";
import ListState from "./list-state";
import Ajax from "../../lib/ajax";
import PageResult from "@/store/entities/page-result";
import appconst from "./../../lib/appconst";

interface ErrorLogState extends ListState<any> {
}
class ErrorLogModule extends ListModule<ErrorLogState, any, any> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<any>(),
    loading: false,
  };
  actions = {
    async getWorkOrderTypeForSelect(context: ActionContext<ErrorLogState, any>, payload: any) {
      const {data:{result} } = await Ajax.get('/api/services/app/report/GetWorkOrderTypeForSelect',{ params: payload.data });
      return result.items;
    },
    async getAll(
      context: ActionContext<ErrorLogState, any>,
      payload: any
    ) {
      context.state.loading = true;
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/ErrorLog/GetAll", {
        params: payload.data,
      });
      context.state.loading = false;
      const page = result as PageResult<any>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },

    async exportErrorLog(
      context: ActionContext<ErrorLogState, any>,
      payload: any
    ) {
      window.open(
        `${
          appconst.remoteServiceBaseUrl
        }export/exportErrorLog${abp.utils.buildQueryString(
          Object.keys(payload.data).map((key) => {
            return {
              name: key,
              value: payload.data[key],
            };
          }),
          true
        )}`,
        "_blank"
      );
    },
  };

  mutations = {
    setCurrentPage(state: ErrorLogState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: ErrorLogState, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const errorLogModule = new ErrorLogModule();
export default errorLogModule;
